import axios from "axios";
import { isTokenExpired, getNewToken, getToken } from "helpers/auth";
import defaultHeaders from "./default-headers";

export const sendMessage = async (params) => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v1/conversations`;

  const response = await axios.post(url, params, {
    headers: {
      ...defaultHeaders,
      Authorization: authorization,
    },
  });

  return response.data;
};
